/* ==========================================================================
   Shoppable Video —— 中间聚焦 + 无缝无限循环（对标 MISSOMA）
   2026-06 返工版（修复对抗式 review 指出的 5 个 blocker）：
     A. 无「自动切换」——只由用户滑动 / 点左右箭头驱动；
     B. 不再用 scrollIntoView，所有定位只动横向轨道 → 根治「滚到别处页面被拽回」；
        瞬移加重入锁(isNormalizing)，杜绝 滚动→normalize→再滚动 的抖动死循环；
     C. 真·无缝无限循环：
        ① 几何一律用 offsetLeft/offsetWidth（布局值，不受 .sv-item 的 scale 变换污染）——
           为此给 track 设 position:relative，使每个 .sv-item 的 offsetParent 就是 track；
        ② 箭头/滑动越界时，用「逻辑索引 curIdx + 等价项瞬移」接住，不再 clamp 卡死；
        ③ 瞬移前临时关闭 scroll-snap，避免 mandatory 吸附把落点改写造成回弹/露白；
        ④ settle 用「连续多帧 scrollLeft 不变」判定（兼容 iOS 惯性），不再用固定 140ms。
   仅「中心项」放大并播放，其余暂停；滚出视口全部暂停。
   ========================================================================== */
(function () {
  'use strict';

  function init(root) {
    if (root.dataset.svBound) return;
    root.dataset.svBound = '1';

    var track = root.querySelector('.sv-track');
    if (!track) return;
    var originals = Array.prototype.slice.call(root.querySelectorAll('.sv-item'));
    if (!originals.length) return;

    // 让每个 .sv-item 的 offsetParent 成为 track —— 这样 offsetLeft 就是相对 track 的
    // 滚动内容坐标，可直接用于 scrollLeft 计算（且不受 transform:scale 影响）。
    track.style.position = 'relative';

    var inView = false;
    var userActed = false;          // 用户是否已交互（交互后不再自动重定位）
    var isNormalizing = false;      // 瞬移重入锁
    var calibrated = false;         // 进视口后是否已二次校准
    var setSize = originals.length;
    var loopOn = setSize >= 3;      // 太少不做无限循环，避免重叠
    var curIdx = 0;                 // 逻辑中心索引（连点/循环的唯一真相源）

    // 桌面端每项宽度：按轨道可视宽度(clientWidth)精确算 → 每屏正好显示 N 个。
    // 用 JS 而非 CSS calc(100%...) —— 因 .sv-track 的 padding-inline 依赖 --sv-w，
    // 与 100% 互相依赖会形成循环、解析成固定值(约 365px)使设置失效。clientWidth 是
    // 可视窗口宽度（不随单项宽度/内边距变化），无循环。手机端保持 CSS 的 --sv-w 不动。
    var perTop = parseInt(root.dataset.svPer, 10) || 4;   // ≥1920px 时的数量（来自「展示数量」设置）
    // 响应式每屏数量：按视口宽度分档。小数(如 4.5)= 整数张 + 半张 peek，提示可继续滑动。
    // 想改档位/数量直接调这里即可（<750 返回 0 → 交给 CSS 的手机端 --sv-w）。
    function perViewFor(w) {
      if (w >= 1920) return perTop;   // 超宽屏：用设置值（默认 7）
      if (w >= 1500) return 5;
      if (w >= 750)  return 4.5;
      return 0;                        // 手机端
    }
    function setItemWidth() {
      var per = perViewFor(window.innerWidth);
      if (!per) { root.style.removeProperty('--sv-w'); return; }
      var gap = parseFloat(getComputedStyle(track).columnGap) || 0;
      var avail = track.clientWidth;
      if (!avail) return;
      // ⌈per⌉−1 个间距：整数张精确铺满；含半张时为 floor 个间距，半张自然露在边缘
      var w = (avail - gap * (Math.ceil(per) - 1)) / per;
      if (w > 0) root.style.setProperty('--sv-w', w + 'px');
    }

    // 把横向轨道固定为「中心卡(最高)」的高度：切换时中心卡放大/缩小只在容器内变化，
    // 容器高度恒定 → 不会因高度抖动而顶动下方模块。高度按解析式算(媒体满高 + 商品信息 +
    // 轨道上下内边距)，不依赖过渡时机；手机端各卡等高、无需固定。
    function lockTrackHeight() {
      if (window.matchMedia('(max-width: 749px)').matches) { track.style.minHeight = ''; return; }
      var svW = parseFloat(getComputedStyle(root).getPropertyValue('--sv-w')) || 0;
      if (!svW) { track.style.minHeight = ''; return; }
      var mult = parseFloat(root.getAttribute('data-sv-center-h')) || 1.6;
      var prod = track.querySelector('.sv-product');
      var productH = prod ? prod.getBoundingClientRect().height : 0;
      var cs = getComputedStyle(track);
      var padB = (parseFloat(cs.paddingTop) || 0) + (parseFloat(cs.paddingBottom) || 0);
      track.style.minHeight = Math.ceil(svW * mult + productH + padB) + 'px';
    }

    function videoOf(item) { return item.querySelector('video'); }

    function makeClone(it) {
      var c = it.cloneNode(true);
      c.classList.add('sv-clone');
      c.setAttribute('aria-hidden', 'true');
      // 克隆项不进 Tab 序、内部链接不可聚焦（避免重复可达的商品链接）
      c.setAttribute('tabindex', '-1');
      Array.prototype.forEach.call(c.querySelectorAll('a,button,[tabindex]'), function (el) {
        el.setAttribute('tabindex', '-1');
      });
      var v = c.querySelector('video');
      // 克隆体永不播放。有封面图(Shopify 视频/已设 poster)→ preload='none' 即可显示首帧，
      // 不再发元数据请求（性能）；无封面图(外部 MP4)才回退 'metadata' 渲染首帧避免空白。
      if (v) { v.preload = v.poster ? 'none' : 'metadata'; v.removeAttribute('autoplay'); v.muted = true; }
      return c;
    }

    // —— 构建无限循环：前后各克隆一整组 → [组A克隆][原组][组C克隆] ——
    if (loopOn) {
      originals.map(makeClone).forEach(function (c) { track.appendChild(c); });         // 后置克隆
      var before = originals.map(makeClone);
      for (var i = before.length - 1; i >= 0; i--) { track.insertBefore(before[i], track.firstChild); } // 前置克隆
    }
    var items = Array.prototype.slice.call(track.querySelectorAll('.sv-item'));
    setItemWidth();   // 先定好单项宽度，后续居中/几何才准确
    lockTrackHeight();   // 固定轨道高度，切换时不顶动下方模块

    // —— 几何：全部用布局值（offsetLeft/offsetWidth），不受 scale 变换污染 ——
    function itemCenter(i) { return items[i].offsetLeft + items[i].offsetWidth / 2; }
    function viewCenter() { return track.scrollLeft + track.clientWidth / 2; }
    function targetScrollFor(i) { return itemCenter(i) - track.clientWidth / 2; }

    function centerIndex() {
      var vc = viewCenter();
      var best = 0, bestDist = Infinity;
      for (var i = 0; i < items.length; i++) {
        var d = Math.abs(itemCenter(i) - vc);
        if (d < bestDist) { bestDist = d; best = i; }
      }
      return best;
    }

    // —— 丝滑滚动：自定义 ease-out 缓动动画，比原生 smooth 更柔和（对标参考站手感）——
    var glideRaf = null;
    function glideTo(targetLeft) {
      if (glideRaf) { cancelAnimationFrame(glideRaf); glideRaf = null; }
      var start = track.scrollLeft, dist = targetLeft - start;
      if (Math.abs(dist) < 1) { track.scrollLeft = targetLeft; return; }
      track.style.scrollSnapType = 'none';                  // 动画期间关吸附，避免逐帧跳动
      var t0 = null, dur = 600;
      function ease(t) { return 1 - Math.pow(1 - t, 3); }   // ease-out cubic，越到末尾越慢，丝滑
      function step(ts) {
        if (t0 === null) t0 = ts;
        var t = (ts - t0) / dur; if (t > 1) t = 1;
        track.scrollLeft = start + dist * ease(t);
        if (t < 1) { glideRaf = requestAnimationFrame(step); }
        else { glideRaf = null; track.style.scrollSnapType = ''; }   // 动画结束恢复吸附
      }
      glideRaf = requestAnimationFrame(step);
    }

    // 只滚动横向轨道（绝不用 scrollIntoView，避免整页跳动）；smooth 走自定义丝滑缓动
    function scrollToItem(i, smooth) {
      if (i < 0 || i >= items.length) return;
      if (smooth) { glideTo(targetScrollFor(i)); }
      else { track.scrollTo({ left: targetScrollFor(i), behavior: 'auto' }); }
    }

    // 瞬移：关 snap + 上锁，避免 mandatory 吸附改写落点、避免瞬移触发的 scroll 再入。
    // 用计数器而非读 inline 现值来恢复——多次并发瞬移(placeStart 双调用等)时只让最后一帧
    // 恢复，且固定恢复成 ''（让 CSS 的 x mandatory 重新生效），杜绝把临时态 'none' 当原值
    // 钉死、永久关闭吸附（否则等于 B3 变相回归）。
    var snapPending = 0;
    function hardScrollTo(left) {
      isNormalizing = true;
      track.style.scrollSnapType = 'none';
      track.scrollLeft = left;
      snapPending++;
      requestAnimationFrame(function () {
        if (--snapPending <= 0) {
          snapPending = 0;
          track.style.scrollSnapType = '';
          isNormalizing = false;
        }
      });
    }

    function applyActive(idx, play) {
      for (var i = 0; i < items.length; i++) {
        var isA = i === idx;
        items[i].classList.toggle('is-active', isA);
        var v = videoOf(items[i]);
        if (!v) continue;
        if (isA && play && inView) {
          if (v.preload !== 'auto') v.preload = 'auto';   // 仅中心项才真正加载视频数据，避免一打开就拉一堆视频
          if (v.paused) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
        } else if (!v.paused) {
          v.pause();
        }
      }
    }

    // 停稳后：若中心落在克隆区，瞬移到「中段等价项」（绝对定位，画面不变、无累积漂移）
    function normalize() {
      if (!loopOn) return;
      var ci = centerIndex();
      var target = ci < setSize ? ci + setSize : (ci >= 2 * setSize ? ci - setSize : -1);
      if (target < 0) return;
      hardScrollTo(targetScrollFor(target));
      curIdx = target;
    }

    // —— settle 判定：连续多帧 scrollLeft 不变才算停稳（兼容 iOS 惯性 / 平滑滚动）——
    var raf = null, watching = false, lastLeft = null, stableFrames = 0, pressing = false;
    function onScroll() {
      if (isNormalizing) return;
      if (raf) cancelAnimationFrame(raf);
      raf = requestAnimationFrame(function () { applyActive(centerIndex(), false); });
      if (!watching) { watching = true; lastLeft = null; stableFrames = 0; requestAnimationFrame(watchSettle); }
    }
    function watchSettle() {
      if (!watching) return;
      // 手指仍按住（慢速拖拽中途短暂静止）不算停稳，避免按住时误触发 normalize 瞬移
      if (pressing) { lastLeft = track.scrollLeft; stableFrames = 0; requestAnimationFrame(watchSettle); return; }
      var l = track.scrollLeft;
      if (l === lastLeft) { stableFrames++; } else { stableFrames = 0; lastLeft = l; }
      if (stableFrames >= 3) { watching = false; onSettle(); return; }
      requestAnimationFrame(watchSettle);
    }
    function onSettle() {
      normalize();              // 若在克隆区 → 等价瞬移回中段
      curIdx = centerIndex();   // 瞬移后 centerIndex 已是中段等价项
      applyActive(curIdx, true);
    }
    track.addEventListener('scroll', onScroll, { passive: true });
    ['pointerdown', 'touchstart'].forEach(function (ev) {
      track.addEventListener(ev, function () { pressing = true; }, { passive: true });
    });
    ['pointerup', 'pointercancel', 'touchend', 'touchcancel'].forEach(function (ev) {
      track.addEventListener(ev, function () { pressing = false; }, { passive: true });
    });

    // —— 鼠标拖拽左右切换（桌面端；触屏走原生滑动）——
    // 关键：只有真正拖动(超过阈值)才接管(关吸附/捕获指针/抑制点击)；纯点击不接管，
    // 保证「点击非中心卡 → 居中」照常工作（之前在 pointerdown 就捕获指针，把 click 目标抢走了）。
    var dragging = false, dragStartX = 0, dragStartLeft = 0, dragMoved = false, dragCaptured = false;
    track.addEventListener('pointerdown', function (e) {
      if (e.pointerType !== 'mouse' || e.button !== 0) return;
      dragging = true; dragMoved = false; dragCaptured = false;
      dragStartX = e.clientX; dragStartLeft = track.scrollLeft;
      if (glideRaf) { cancelAnimationFrame(glideRaf); glideRaf = null; }   // 打断进行中的丝滑动画
    });
    track.addEventListener('pointermove', function (e) {
      if (!dragging) return;
      var dx = e.clientX - dragStartX;
      if (!dragMoved) {
        if (Math.abs(dx) <= 4) return;                 // 未超阈值 → 仍当点击，不接管
        dragMoved = true;
        track.style.scrollSnapType = 'none';
        track.classList.add('sv-dragging');
        try { track.setPointerCapture(e.pointerId); dragCaptured = true; } catch (err) {}
      }
      e.preventDefault();
      track.scrollLeft = dragStartLeft - dx;
      userActed = true;
    });
    function endMouseDrag(e) {
      if (!dragging) return;
      dragging = false;
      if (!dragMoved) return;                          // 纯点击 → 不干预，交给卡片 click 居中
      track.classList.remove('sv-dragging');
      if (dragCaptured) { try { track.releasePointerCapture(e.pointerId); } catch (err) {} }
      scrollToItem(centerIndex(), true);               // 松开 → 丝滑居中最近一张（glideTo 会恢复吸附）
    }
    ['pointerup', 'pointercancel'].forEach(function (ev) { track.addEventListener(ev, endMouseDrag); });
    // 真正拖动后抑制本次点击（避免松手误触发卡片居中/商品链接跳转）；纯点击不抑制
    track.addEventListener('click', function (e) {
      if (dragMoved) { e.preventDefault(); e.stopPropagation(); }
      dragMoved = false;
    }, true);

    // 点击非中心项 → 居中（点哪个居中哪个，越界由 onSettle 的 normalize 接住）
    items.forEach(function (it, i) {
      var media = it.querySelector('.sv-media');
      if (!media) return;
      media.addEventListener('click', function (e) {
        if (!it.classList.contains('is-active')) {
          e.preventDefault();
          userActed = true;
          curIdx = i;
          scrollToItem(i, true);
        }
      });
    });

    // 左右箭头：逻辑索引 ±1；越界先「等价瞬移」回中段再走，永远有下一项、首尾相接
    function navStep(dir) {
      userActed = true;
      if (loopOn) {
        // 越界先「等价瞬移」回中段——走 hardScrollTo（关 snap + 上锁），与 normalize 同一路径，
        // 避免裸写 scrollLeft 被吸附改写、或误触发 watchSettle 与紧随的平滑滚动打架。
        if (curIdx < setSize) { curIdx += setSize; hardScrollTo(targetScrollFor(curIdx)); }
        else if (curIdx >= 2 * setSize) { curIdx -= setSize; hardScrollTo(targetScrollFor(curIdx)); }
        curIdx += dir;                                  // 此时 curIdx ∈ [setSize-1, 2*setSize]
        scrollToItem(curIdx, true);
      } else {
        curIdx = Math.max(0, Math.min(items.length - 1, curIdx + dir));
        scrollToItem(curIdx, true);
      }
    }
    root.querySelectorAll('.sv-nav').forEach(function (btn) {
      btn.addEventListener('click', function () {
        navStep(btn.classList.contains('sv-nav--next') ? 1 : -1);
      });
    });

    // 仅「进视口」才播放中心项；滚出视口全部暂停（无自动切换）
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        inView = en.isIntersecting;
        // 首次进入视口、用户尚未交互时，二次校准初始居中（规避首屏布局未稳的偏移）
        if (inView && !userActed && !calibrated) { calibrated = true; placeStart(); }
        applyActive(centerIndex(), inView);
      });
    }, { threshold: 0.25 });
    io.observe(root);

    // 初始定位到原组第一个（横向、不动整页；关 snap 防吸附改写）
    function placeStart() {
      var startIdx = loopOn ? setSize : 0;
      curIdx = startIdx;
      lockTrackHeight();        // 排版完成后再锁一次高度（此时商品信息高度已稳定）
      hardScrollTo(targetScrollFor(startIdx));
      applyActive(startIdx, inView);
    }
    // 卡片是固定宽 + CSS aspect-ratio 占位，布局即时稳定；双 rAF 确保克隆已排版
    requestAnimationFrame(function () { requestAnimationFrame(placeStart); });

    // 窗口缩放 / 横竖屏切换：把当前中心重新对齐（防止 --sv-w 改变后中心漂移）
    var resizeT = null;
    function onResize() {
      if (resizeT) clearTimeout(resizeT);
      resizeT = setTimeout(function () { setItemWidth(); lockTrackHeight(); scrollToItem(curIdx, false); }, 150);
    }
    window.addEventListener('resize', onResize);

    // 主题编辑器内删除/重排该 section 时清理，避免遗留 observer / 监听
    root._svCleanup = function () {
      io.disconnect();
      track.removeEventListener('scroll', onScroll);
      window.removeEventListener('resize', onResize);
      if (raf) cancelAnimationFrame(raf);
      if (resizeT) clearTimeout(resizeT);
      watching = false;
    };
  }

  function boot(scope) {
    var r = scope && scope.querySelectorAll ? scope : document;
    r.querySelectorAll('[data-shoppable-video]').forEach(init);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(); });
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
  document.addEventListener('shopify:section:unload', function (e) {
    (e.target.querySelectorAll ? e.target.querySelectorAll('[data-shoppable-video]') : []).forEach(function (root) {
      if (typeof root._svCleanup === 'function') root._svCleanup();
    });
  });
})();
